import { Button, Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle, Label, Switch, Textarea, } from '@cargomatic/ui';
import Alert from 'components/ui/Alert';
import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { showToast } from 'stores/ToastStore';
import { evaluateBillingStatusByReferenceNumbers } from 'utils/ShipmentWebAPIUtils';
import useModal from 'hooks/useModal';
import { ConfirmationModal } from 'components/v2/confirmation-modal';
export default function BulkEvaluateBillingStatus() {
    const [shipmentIdsText, setShipmentIdsText] = useState('');
    const [forcePauseBillStatusEvaluation, setForcePauseBillStatusEvaluation] = useState(false);
    const [errors, setErrors] = useState({});
    const hasErrors = useMemo(() => {
        return Object.keys(errors).length > 0;
    }, [errors]);
    const { visible: evaluateBillingStatusConfirmationModalVisible, show: showEvaluateBillingStatusConfirmationModal, close: closeEvaluateBillingStatusConfirmationModal, } = useModal();
    function validate() {
        const errors = {};
        if (shipmentIds.length === 0) {
            errors.shipmentIds = `${t('SHIPMENT_IDS')} ${t('REQUIRED')}`;
        }
        setErrors(errors);
        return errors;
    }
    const { t } = useTranslation();
    const shipmentIds = useMemo(() => {
        if (!shipmentIdsText) {
            return [];
        }
        const items = shipmentIdsText.split('\n').reduce((list, line) => {
            return list.concat(line
                .split(',')
                .map((item) => item.trim())
                .filter((item) => !!item));
        }, []);
        return items;
    }, [shipmentIdsText]);
    function handleShipmentIdsTextChange(e) {
        setShipmentIdsText(e.target.value);
    }
    function handleShowConfirmationModal() {
        const errors = validate();
        if (Object.keys(errors).length > 0) {
            return;
        }
        showEvaluateBillingStatusConfirmationModal();
    }
    async function handleSave() {
        const errors = validate();
        if (Object.keys(errors).length > 0) {
            return;
        }
        try {
            await evaluateBillingStatusByReferenceNumbers({
                shipmentReferences: shipmentIds,
                forcePauseBillStatusEvaluation,
            });
            showToast(`Billing Status evaluated!`);
        }
        catch (e) {
            showToast(`There was a problem processing your request.`);
            console.error(e);
        }
    }
    return (React.createElement(Card, null,
        React.createElement(CardHeader, null,
            React.createElement(CardTitle, null, "Bulk Reevaluate Billing Status"),
            React.createElement(CardDescription, null, "Paste in the reference numbers to reevaluate the billing status.")),
        React.createElement(CardContent, null,
            forcePauseBillStatusEvaluation && (React.createElement(Alert, { type: "warning", className: "my-4" }, "Any previously paused items will be unpaused and re-evaluated.")),
            hasErrors && (React.createElement(Alert, { type: "error", className: "my-4" }, "Please fill out all required fields.")),
            React.createElement("div", { className: "space-y-4" },
                React.createElement("div", { className: "flex items-center space-x-2" },
                    React.createElement(Switch, { id: "force-evaluations", checked: forcePauseBillStatusEvaluation, onCheckedChange: setForcePauseBillStatusEvaluation }),
                    React.createElement(Label, { htmlFor: "pause-automated-evaluations" }, "Force Evaluate")),
                React.createElement("div", { className: "space-y-2" },
                    React.createElement(Label, { htmlFor: "shipmentIds" }, "Shipment Reference Numbers"),
                    React.createElement(Textarea, { value: shipmentIdsText, id: "shipmentIds", onChange: handleShipmentIdsTextChange }))),
            evaluateBillingStatusConfirmationModalVisible && (React.createElement(ConfirmationModal, { open: evaluateBillingStatusConfirmationModalVisible, onHide: closeEvaluateBillingStatusConfirmationModal, title: t('EVALUATE_BILLING_STATUS'), description: t('EVALUATE_BILLING_STATUS_CONFIRMATION', {
                    count: shipmentIds.length,
                }), onConfirm: async () => {
                    await handleSave();
                } }))),
        React.createElement(CardFooter, null,
            React.createElement(Button, { onClick: handleShowConfirmationModal }, "Save"))));
}
